<template>
	<form-entry v-if="mode == 'entry' || mode == 'filter' || mode == 'preview'"
				:col="col"
				:task="task"
				:value="value"
				:entity="entity"
				:display-type="displayType"
				:props="props"
				:mode="mode"
				:use-validation="useValidation"
				:use-multilanguage="useMultilanguage"
				:is-loading="isLoading"
				:submit-resource-key="submitResourceKey"
				v-on:change="handleChange"
				ref="FormEntryRef">
		<slot></slot>
	</form-entry>

	<form-generator v-else :props="props" />
</template>

<script>
	import FormEntry from './form-entry'
	import FormGenerator from './form-generator'

	export default {
		emits:['change'],
		components:
		{
			'form-entry': FormEntry,
			'form-generator': FormGenerator
		},

		data()
		{
			return {
			}
		},

		props:
		{
			'entity': {
				type: Function
			},

			'props': {
				type: Object
			},

			'task': {
				type: Function
			},

			'displayType': {
				type: String
			},

			'col': {
				type: String
			},

			'mode': {
				type: String,
				default: 'entry'
			},

			'value': {
				type: Object,
				default: null
			},

			'useValidation': {
				type: Boolean,
				default: true
			},

			'useMultilanguage': {
				type: Boolean,
				default: true
			},

			'isLoading': {
				type: Boolean
			},

			'submitResourceKey': {
				type: String,
				default: 'global.save'
			},
		},

		methods: {
			getValue() {

				if (['entry', 'filter'].includes(this.mode)) {
					return this.$refs.FormEntryRef.getValue()
				}

				return undefined;
			},

			getErrorLength()
			{
				if (['entry', 'filter'].includes(this.mode))
				{
					return this.$refs.FormEntryRef.getErrorLength()
				}

				return 0;
			},

			handleChange(x)
			{
				this.$emit('change', x)
			}
		}
	}
</script>
